/* eslint-disable string-to-lingui/missing-lingui-transformation */
import { ChevronLeft } from 'lucide-react'
import React from 'react'
import { Link } from 'react-router-dom'
import { Column } from './GenericDataPage'

interface GenericDetailPageProps<T> {
    backButtonText: string
    title: React.ReactNode
    data: T
    backRoute: string
    columns: Column<T>[]
    actionButtons?: React.ReactNode[]
    additionalComponents?: React.ReactNode[]
}

const GenericDetailPage = <T extends object>({
    backButtonText,
    title,
    data,
    backRoute,
    columns,
    actionButtons,
    additionalComponents
}: GenericDetailPageProps<T>) => {
    return (
        <div className='flex flex-col h-screen'>
            {/* Fixed Header */}
            <div className='flex-none bg-white border-b border-gray-200 shadow-sm'>
                <div className='px-4'>
                    <div className='flex items-center h-16'>
                        {/* Back Button */}
                        <Link to={backRoute} className='flex items-center text-gray-600 hover:text-gray-900 transition-colors mr-6'>
                            <ChevronLeft className='w-5 h-5' />
                            <span className='text-sm font-medium'>{backButtonText}</span>
                        </Link>

                        {/* Title and Patient Info */}
                        {title}
                    </div>
                </div>
            </div>

            {/* Action Buttons */}
            {actionButtons && actionButtons.length > 0 && (
                <div className='flex-none bg-white border-b border-gray-200 shadow-sm'>
                    <div className='px-4 py-2'>
                        <div className='flex items-center justify-end'>{actionButtons}</div>
                    </div>
                </div>
            )}

            {/* Scrollable Content */}
            <div className='flex-1 overflow-auto bg-gray-50'>
                <div className='px-4 py-4'>{additionalComponents}</div>
            </div>
        </div>
    )
}

export default GenericDetailPage
